<template>
  <v-container fluid>
    <v-form class="pa-0" ref="form" v-model="validForm" lazy-validation>

      <v-toolbar flat color="transparent">

        <v-toolbar-title>
          <h2 v-if="!$route.params.id" :class="$vuetify.theme.isDark ? 'white--text' : ''">
            Crear Material
          </h2>

          <h2 v-else :class="$vuetify.theme.isDark ? 'white--text' : ''">
            Editar Material
          </h2>

        </v-toolbar-title>

        <v-spacer />

        <v-btn :disabled="!validForm" class="mx-1" elevation="0" color="primary" rounded @click="validateForm">
          Guardar
        </v-btn>

        <v-btn class="mx-1" elevation="0" color="error" rounded v-if="$route.params.id" @click="destroyDialog = true">
          Eliminar
        </v-btn>

      </v-toolbar>


      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title class="pb-2">
              <h4 :class="$vuetify.theme.isDark ? 'white--text' : ''">
                <v-icon :color="$vuetify.theme.isDark ? 'white' : 'secondary'">mdi-clipboard-text</v-icon>
                Descripción
              </h4>
            </v-card-title>

            <v-card-text>
              <v-row>

                <v-col cols="12" md="6">
                  <v-text-field :rules="emptyRule" hide-details dense outlined v-model="payload.name" label="Nombre">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="px-6 py-0">
                  <v-row align="center" justify="center">

                    <h4 class="mb-0 pr-3" :class="$vuetify.theme.isDark ? 'white--text' : ''">Activo:</h4>
                    <v-switch :color="$vuetify.theme.isDark ? 'primary' : 'secondary'" v-model="payload.enabled">
                    </v-switch>
                  </v-row>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="destroyDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">¿Estas seguro?</v-card-title>

          <v-card-text>
            Una vez elimines el registro, no podrás recuperarlo.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn rounded color="primary" text @click="destroyDialog = false">
              Mejor no
            </v-btn>

            <v-btn elevation="0" class="pa-4" rounded color="error" @click="destroy">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-form>
  </v-container>
</template>


<script>
  export default {
    data() {
      return {
        destroyDialog: false,
        validForm: true,
        emptyRule: [v => !!v || 'Necesario'],
        payload: {
          id: null,
          name: null,
          enabled: true
        }
      }
    },
    methods: {
      validateForm() {
        if (this.$refs.form.validate()) {
          (this.$route.params.id ? this.update() : this.store())
        }
      },

      edit() {
        this.$axios
          .get(`/admin/materials/${this.$route.params.id}/edit`)
          .then((response) => {
            // console.log(response.data)
            this.payload = response.data.item
          })
      },

      store() {
        let formData = new FormData();

        // Loops the payload and inserts it inside formData
        Object.entries(this.payload).forEach(([key, value]) => {
          formData.append(key, value)
        })

        this.$axios
          .post('/admin/materials', formData)
          .then((response) => {
            // console.log(response.data)
            this.$store.commit('OPEN_SNACKBAR', response.data);
            (response.data.success ? this.$router.push('/materials') : '')
          })
          .catch((error)=>{
            console.log(error);
          });
      },

      update() {
        let formData = new FormData();

        // Loops the payload and inserts it inside formData
        Object.entries(this.payload).forEach(([key, value]) => {
          formData.append(key, value)
        })

        // Sends photos
        formData.append('photos', JSON.stringify(this.photos))

        // Laravel put workaround
        formData.append('_method', 'PUT')

        this.$axios
          .post(`/admin/materials/${this.$route.params.id}`, formData)
          .then((response) => {
            // console.log(response.data)
            this.$store.commit('OPEN_SNACKBAR', response.data);
            (response.data.success ? this.$router.push('/materials') : '')
          })
          .catch((error)=>{
            console.log(error);
          });
      },

      destroy() {
        let formData = new FormData();

        // Laravel delete workaround
        formData.append('_method', 'DELETE')

        this.$axios
          .post(`/admin/materials/${this.$route.params.id}`, formData)
          .then((response) => {
            // console.log(response.data)
            this.$store.commit('OPEN_SNACKBAR', response.data);
            (response.data.success ? this.$router.push('/materials') : '')
          })
          .catch((error)=>{
            console.log(error);
          });
      }
    },

    mounted() {
      if (this.$route.params.id) {
        this.edit()
      }
    }
  }
</script>